import { actionColor } from "@/lib/format";
import { TrendingUp, TrendingDown, MinusCircle } from "lucide-react";

export function SignalBadge({ action, confidence, size = "lg", testId = "macro-signal-badge" }) {
  const c = actionColor(action);
  const Icon = action === "BUY" ? TrendingUp : action === "SELL" ? TrendingDown : MinusCircle;
  const isLg = size === "lg";
  return (
    <div
      data-testid={testId}
      className={`signal-glow inline-flex items-center gap-2 rounded-full font-display font-bold tracking-tight ${isLg ? "px-6 py-2.5 text-2xl" : "px-3 py-1 text-xs"}`}
      style={{ color: c.text, background: c.bg, border: `1px solid ${c.text}55`, "--glow": c.glow }}
    >
      <Icon size={isLg ? 26 : 14} strokeWidth={2.5} />
      <span>{action}</span>
      {confidence != null && (
        <span className={`font-mono-num ${isLg ? "text-base" : "text-[10px]"} opacity-80`}>{confidence}%</span>
      )}
    </div>
  );
}
